import {
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { history, useModel } from '@umijs/max';
import type { MenuProps } from 'antd';
import { Spin } from 'antd';
import { createStyles } from 'antd-style';
import React, { useEffect, useRef } from 'react';
import { flushSync } from 'react-dom';
import HeaderDropdown from '../HeaderDropdown';
import { logoutAndRedirect } from '@/utils/oidc-client'
export type GlobalHeaderRightProps = {
  menu?: boolean;
  children?: React.ReactNode;
};

export const AvatarName = () => {
  const { initialState } = useModel('@@initialState');
  const { currentUser } = initialState || {};
  return <span className="anticon">{currentUser?.employeeChineseName}</span>;
};

const useStyles = createStyles(({ token }) => {
  return {
    action: {
      display: 'flex',
      height: '48px',
      marginLeft: 'auto',
      overflow: 'hidden',
      alignItems: 'center',
      padding: '0 8px',
      cursor: 'pointer',
      borderRadius: token.borderRadius,
      '&:hover': {
        backgroundColor: token.colorBgTextHover,
      },
    },
  };
});

export const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({
  menu,
  children,
}) => {
  /**
   * 退出登录，并且将当前的 url 保存
   */
  // const loginOut = async () => {
  //   // await outLogin();
  //   const { search, pathname } = window.location;
  //   const urlParams = new URL(window.location.href).searchParams;
  //   const searchParams = new URLSearchParams({
  //     redirect: pathname + search,
  //   });
  //   /** 此方法会跳转到 redirect 参数所在的位置 */
  //   const redirect = urlParams.get('redirect');
  //   // Note: There may be security issues, please note
  //   if (window.location.pathname !== OIDC_REDIRECT_LOGIN_URL && !redirect) {
  //     history.replace({
  //       pathname: OIDC_REDIRECT_LOGIN_URL,
  //       search: searchParams.toString(),
  //     });
  //   }
  // };
  const { styles } = useStyles();

  const { initialState, setInitialState } = useModel('@@initialState');
  const fetchingRef = useRef(false);
  // 如果 currentUser 不存在，尝试自动拉取一次用户信息（方案B）
  useEffect(() => {
    const autoFetch = async () => {
      if (fetchingRef.current) return; // 防并发
      if (!initialState?.currentUser && initialState?.fetchUserInfo) {
        fetchingRef.current = true;
        try {
          const user = await initialState.fetchUserInfo();
          if (user) {
            setInitialState(s => ({ ...s, currentUser: user }));
          }
        } catch (e) {
          // 保持静默，避免重复弹出错误；可按需加入 message.warning
          console.warn('[AvatarDropdown] auto fetch user failed', e);
        } finally {
          fetchingRef.current = false;
        }
      }
    };
    autoFetch();
  }, [initialState?.currentUser,
  initialState?.fetchUserInfo,
    setInitialState]);

  const onMenuClick: MenuProps['onClick'] = (event) => {
    const { key } = event;
    if (key === 'logout') {
      flushSync(() => {
        setInitialState((s) => ({ ...s, currentUser: undefined }));
      });
      logoutAndRedirect();
      return;
    }
    history.push(`/account/${key}`);
  };

  const loading = (
    <span className={styles.action}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const { currentUser } = initialState;

  if (!currentUser || !currentUser.employeeChineseName) {
    return loading;
  }

  const menuItems = [
    ...(menu
      ? [
        {
          key: 'center',
          icon: <UserOutlined />,
          label: '个人中心',
        },
        {
          key: 'settings',
          icon: <SettingOutlined />,
          label: '个人设置',
        },
        {
          type: 'divider' as const,
        },
      ]
      : []),
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
    },
  ];

  return (
    <HeaderDropdown
      menu={{
        selectedKeys: [],
        onClick: onMenuClick,
        items: menuItems,
      }}
    >
      {children}
    </HeaderDropdown>
  );
};
